import logo from "../../assets/images/logo.png";

interface KalixLogoProps {
  height?: number;
}

const KalixLogo = ({ height = 48 }: KalixLogoProps) => {
  return (
    <img src={logo} alt="" style={{ height, width: "auto" }} />
  );
};

export default KalixLogo;
